<template>
  <div class='sign-up-thx-wrapper'>
    <HeroImage
      title='Sign up'
      subtitle='Get more information and updates <br>delivered straight to your inbox.'
      :image='imageLg'
      :image__sm='imageSm'
      alt='Adult with ADHD managing her symptoms during work hours | JORNAY PM® (methylphenidate HCl extended-release capsules)'
    >
    </HeroImage>

    <div class='sign-up-thx'>

      <!-- <div class='unknown-page__heading'>
        <div class='container'>
          <div class='row'>
            <div class='col-md-auto right-side sign-up-thx__image'>
              <img src='@/assets/images/inbox.png' alt='Inbox' />
            </div>
            <div class='col-md left-side'>
              <h1>Thanks for signing up!
                <span>Check your inbox for updates</span>
              </h1>
            </div>
          </div>
        </div>
      </div> -->

      <div class='sign-up-thx__inner unknown-page__inner'>
        <div class=''>
          <h2 class='sign-up-thx__caption mb-0 mx-5'>
            While you’re here, you may find the following pages helpful:
          </h2>
        </div>
        <nav class='unknown-page__navigation'>
          <ul class='unknown-page__navigation-list'>
            <li class='def-btn def-btn--golden'>
              <a class='fw-extrabold' href='/savings'>Savings</a>
            </li>
            <li class='def-btn def-btn--golden'>
              <a class='fw-extrabold' href='/what-is-adhd'>WHAT IS ADHD?</a>
            </li>
            <li class='def-btn def-btn--golden'>
              <a class='fw-extrabold' href='/how-jornay-pm-works'>About jornay pm</a>
            </li>
            <li class='def-btn def-btn--golden'>
              <a class='fw-extrabold' href='/resources'>Resources</a>
            </li>
          </ul>
        </nav>

      </div>
    </div>
  </div>
</template>

<script>
import HeroImage from '../../components/elements/HeroImage.vue'
import imageLg from '@/assets/images/3_25/sign-up-thanks/hero@2x.webp'
import imageSm from '@/assets/images/3_25/sign-up-thanks/hero_s@2x.webp'

export default {
  name: 'SignUpThx',
  components: {
    HeroImage
  },
  data () {
    return {
      imageLg,
      imageSm
    }
  }
}
</script>

<style lang='scss'>
.sign-up-thx-wrapper {
  .hero-image p {
    margin-bottom: 40px;
    @media (min-width: 900px) {
      margin-bottom: 120px;
    }
  }
  .sign-up-thx {
    nav li:not(:last-of-type) {
      margin-bottom: 20px;
      @media (min-width: 900px) {
        margin-bottom: 23px;
      }
    }
    .unknown-page__navigation-list {
      margin-top: 50px;
      @media (min-width: 900px) {
        margin-top: 62px;
      }
    }
    h2 {
      margin-top: 63px;
      @media (min-width: 900px) {
        margin-top: 62px;
      }
    }
  }
}
</style>
